let db_results = {
    db_errors: [
        {code: 0, description: ''},
        {code: -5, description: 'Your new password must be different from your current one.'}
    ]
}

export default db_results